import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Inject,
  Renderer2,
  ViewContainerRef,
  ElementRef,
  Output,
  EventEmitter,
  ViewChild
} from '@angular/core';
import {Project} from '../../../data/project/project';
import {ProjectFile} from '../../../data/project/project-file';
import {ProjectService} from '../../../data/project/project.service';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {WsService} from '../../../../data/ws.service';
import {WsUpdateResponce} from '../../../../data/ws-update-responce';
import {trackEntityById, API_URL} from 'projects/core/src/public-api';
import {EntityProject} from '../../../data/project/entity-project';
import {MatSnackBar, MatSnackBarRef, SimpleSnackBar} from '@angular/material/snack-bar';
import {DeviceDetectorService} from 'ngx-device-detector';
import {PdfPreviewDialogComponent} from '../../pdf-preview-dialog/pdf-preview-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ImageGalleryCarouselComponent} from '../../image-gallery-carousel/image-gallery-carousel.component';
import {Gallery} from 'angular-gallery';
import {DomSanitizer} from '@angular/platform-browser';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {Subject, Subscription} from 'rxjs';
import {FileUpload} from 'primeng/fileupload';
import {FileService} from '../../../../../../../../core/src/lib/misc/data/file/file.service';
import {FileOpenerService} from '../../../utils/fileOpener.service';

@Component({
  selector: 'app-files-block',
  templateUrl: './files-block.component.html',
  styleUrls: ['./files-block.component.scss'],
  providers: [DeviceDetectorService]
})
@RxJSUnsubscribe
export class FilesBlockComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  project: Project;

  progressBar: number;

  trackEntityById = trackEntityById;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  isDesktop: boolean;
  isMobile: boolean;

  @Output()
  filesOpened = new EventEmitter<any>()

  @ViewChild('filesForm', {static: false})
  filesForm: FileUpload;

  wsSub: Subscription;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    private snackBar: MatSnackBar,
    protected wsService: WsService,
    private deviceService: DeviceDetectorService,
    protected projectService: ProjectService,
    private dialog: MatDialog,
    protected viewContainerRef: ViewContainerRef,
    protected renderer: Renderer2,
    protected fileService: FileService,
    protected fileOpenerService: FileOpenerService,
    protected elementRef: ElementRef
  ) {
  }

  ngOnInit() {
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();

    this.projectService.getProjectFiles(this.project.id).subscribe(files => {
      this.project.files = files;
    })

    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<EntityProject>>('/topic/update/model.file.ProjectFile', this)
      .pipe(
        filter(updateInfo => updateInfo.entity.project?.id === this.project.id),
        debounceTime(2000)
      )
      .subscribe(updateInfo => {
        this.projectService.getProjectFiles(this.project.id).subscribe(files => this.project.files = files)
      })
  }

  openFile(projectFile: ProjectFile) {
    this.filesOpened.emit();

    if (projectFile.ext === 'pdf') {
      this.openPdfLabels(projectFile);

    } else if (projectFile.ext === 'jpg' || projectFile.ext === 'jpeg' || projectFile.ext === 'png' || projectFile.ext === 'webp') {
      const imgFileLinks = [];

      this.project.files.forEach(file => {
        if (file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'webp') {
          imgFileLinks.push(this.fileService.getDownLoadFileLink(file.id))
        }
      });

      this.openGallery(projectFile, imgFileLinks);
    } else {
      this.fileOpenerService.downloadFile(projectFile.id)
    }
  }

  openGallery(projectFile: ProjectFile, imgFileLinks: string[]): void {
    const cpDialogRef = this.fileOpenerService.openGallery(projectFile, imgFileLinks, true)

    cpDialogRef.afterClosed().subscribe(result => {
      this.filesOpened.emit();
    })

  }

  openPdfLabels(projectFile: ProjectFile): void {
    const cpDialogRef = this.fileOpenerService.openPdfLabels(projectFile, true)


    cpDialogRef.afterOpened().subscribe(() => {
      this.renderer.setStyle((this.elementRef.nativeElement as HTMLElement).parentElement.parentElement.parentElement.parentElement.parentElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      this.renderer.setStyle((this.elementRef.nativeElement as HTMLElement).parentElement.parentElement.parentElement.parentElement.parentElement, 'display', 'flex')

      this.filesOpened.emit();
    })
  }

  uploadFile(files, filesForm?) {

    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    this.projectService.uploadFile(fileArray, this.project.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3
      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.project.files = this.project.files.concat(projectFiles)
        this.progressBar = 0
      }

      filesForm.clear();
    }, error => {
      this.progressBar = 0
      this.openSnackBar(error.message)
    })
  }

  deleteFile(file: ProjectFile) {
    this.projectService.deleteFile(file.id, this.project.id).subscribe(deleted => {

      const index = this.project.files.indexOf(file, 0);
      if (index > -1) {
        this.project.files.splice(index, 1);
      }
    })

  }

  onProgress(event) {
    this.progressBar = event.progress;

    if (this.progressBar === 100) {
    }
  }

  updateProgressBar(percent: number) {
    this.progressBar = percent;
  }

  openSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'file-error-snackbar',
      verticalPosition: 'top',
    });
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getIcon(ext: string) {
    return this.fileService.getIcon(ext)
  }

  getTinyIcon(fileId: number) {
    return this.fileService.getImageThumbNail(fileId)
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  chooseFile() {
    this.filesForm.choose()
  }

}
